import Vue from 'vue'
import VueRouter from 'vue-router';
import CommonPage from '../components/common/commonPage.vue'
// import index from '@/view/index.vue'
import jobInfo from '../view/jobInfo.vue'

const hostname = window.location.hostname;
const isSoucaigroup = hostname.includes('soucaigroup')

Vue.use(VueRouter)
const infoCenter = resolve => require(['../view/infoCenter.vue'], resolve)
const login = resolve => require(['../view/login.vue'], resolve)
const register = resolve => require(['../view/register.vue'], resolve)
const userInfo = resolve => require(['../view/userInfo.vue'], resolve)
const companyDetail = resolve => require(['@/view/companyDetail.vue'], resolve)
const search = resolve => require(['../view/searchRes.vue'], resolve)
const hrUserInfo = resolve => require(['../view/hrViews/userInfo.vue'], resolve)


// 根据域名设置不同的路由配置
let routes = []

if (isSoucaigroup) {
    // soucaigroup 域名使用优化后的路由（根路径直接显示首页）
    routes = [
        {
            path: '/',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'index',
                    component: (resolve) => require(["@/view/index.vue"], resolve),
                }
            ]
        },
        {
            path: '/jobInfo',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'jobInfo',
                    component: jobInfo
                }
            ]
        },
        {
            path: '/infoCenter',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'infoCenter',
                    component: infoCenter
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/register',
            name: 'register',
            component: register
        },
        {
            path: '/userInfo',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'userInfo',
                    component: userInfo
                }
            ]
        },
        {
            path: '/companyDetail',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'companyDetail',
                    component: companyDetail
                }
            ]
        },
        {
            path: '/search',
            component: CommonPage,
            children: [
                {
                    path: '',
                    name: 'search',
                    component: search
                }
            ]
        },
        {
            path: '/hrView',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'hrView',
                    component: hrUserInfo
                }
            ]
        },
        {
            path: '/article/index',
            name: 'article-index',
            component: (resolve) => require(["@/view/article/index.vue"], resolve),
        },
        {
            path: '/article/detail',
            name: 'article-detail',
            component: (resolve) => require(["@/view/article/detail.vue"], resolve),
        },
        {
            path: '/news/index',
            name: 'news-index',
            component: (resolve) => require(["@/view/news/index.vue"], resolve),
        },
        {
            path: '/news/detail',
            name: 'news-detail',
            component: (resolve) => require(["@/view/news/detail.vue"], resolve),
        },
    ]
} else {
    // kuailework 域名使用原来的路由（带 /index 重定向）
    routes = [
        {
            path: '/',
            redirect: '/index' // 根路径重定向到 /index
        },
        {
            path: '/index',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'index',
                    component: (resolve) => require(["@/view/index.vue"], resolve),
                }
            ]
        },
        {
            path: '/jobInfo',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'jobInfo',
                    component: jobInfo
                }
            ]
        },
        {
            path: '/infoCenter',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'infoCenter',
                    component: infoCenter
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/register',
            name: 'register',
            component: register
        },
        {
            path: '/userInfo',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'userInfo',
                    component: userInfo
                }
            ]
        },
        {
            path: '/companyDetail',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'companyDetail',
                    component: companyDetail
                }
            ]
        },
        {
            path: '/search',
            component: CommonPage,
            children: [
                {
                    path: '',
                    name: 'search',
                    component: search
                }
            ]
        },
        {
            path: '/hrView',
            component: CommonPage,
            children: [
                {
                    path: '/',
                    name: 'hrView',
                    component: hrUserInfo
                }
            ]
        },
        {
            path: '/article/index',
            name: 'article-index',
            component: (resolve) => require(["@/view/article/index.vue"], resolve),
        },
        {
            path: '/article/detail',
            name: 'article-detail',
            component: (resolve) => require(["@/view/article/detail.vue"], resolve),
        },
        {
            path: '/news/index',
            name: 'news-index',
            component: (resolve) => require(["@/view/news/index.vue"], resolve),
        },
        {
            path: '/news/detail',
            name: 'news-detail',
            component: (resolve) => require(["@/view/news/detail.vue"], resolve),
        },
    ]
}

let RouterConfig = {}
if (isSoucaigroup) {
    RouterConfig = {
        mode: 'history',
        routes: routes
    };
} else {
    RouterConfig = {
        base: 'recruit',
        mode: 'history',
        routes: routes
    };
}

const router = new VueRouter(RouterConfig);
router.afterEach(() => {
    window.scrollTo(0, 0);
});
export default router